import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=aa668ba4&scoped=true"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa668ba4",
  null
  
)

export default component.exports